import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";
import { type ReactNode } from "react";

export interface ModalProps {
  open:         boolean;
  onClose:      () => void;
  title:        string;
  description?: string;
  children:     ReactNode;
  className?:   string;
}

export function Modal({
  open,
  onClose,
  title,
  description,
  children,
  className,
}: ModalProps) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(v) => {
        if (!v) onClose();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/60" />
        <Dialog.Content
          className={clsx(
            "fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2",
            "w-full max-w-md rounded-lg bg-surface shadow-card",
            "p-6 focus:outline-none",
            className,
          )}
          onEscapeKeyDown={onClose}
          onPointerDownOutside={onClose}
        >
          {/* Header */}
          <div className="mb-5 pr-6">
            <Dialog.Title className="text-base font-semibold text-fg">
              {title}
            </Dialog.Title>
            {description && (
              <Dialog.Description className="mt-1 text-sm text-muted">
                {description}
              </Dialog.Description>
            )}
          </div>

          {children}

          {/* Close button */}
          <Dialog.Close asChild>
            <button
              aria-label="Закрыть"
              className={clsx(
                "absolute right-4 top-4 rounded p-1 text-muted transition-colors",
                "hover:bg-border hover:text-fg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent",
              )}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                aria-hidden
              >
                <path
                  d="M1 1l12 12M13 1L1 13"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
